import {
    put, all, takeLatest,
} from 'redux-saga/effects';
import _ from 'underscore';

import {
    SET_COOKIE_GROUP,
    setCookie,
} from '../reduxModules/ConsentManagementPlatform';

export function* callAction(action) {
    const { cookiesIds, areAccepted } = action.payload;
    yield all(_.map(cookiesIds, (cookieId) => (
        put(setCookie(cookieId, areAccepted))
    )));
}

export function* watch() {
    yield takeLatest(SET_COOKIE_GROUP, callAction);
}
